module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_email_building_and_campaigns.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_email_building_and_campaigns.png
// module id = P/Wr
// module chunks = 0